export default __webpack_public_path__ + "static/media/about-carousel-7-india.0b3c43e6.jpg";